import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ControlVehiculosService } from 'src/app/services/admin/control-vehiculos-service/control-vehiculos.service';
import { ConfirmDialog } from 'src/app/shared/confirmdialog/confirmdialog.component';
import { Gtp } from 'src/app/shared/gtp';
import { trigger, transition, style, animate, stagger, query } from '@angular/animations';
import { Router } from '@angular/router';
import { ControlPerfil } from '../control-vehiculos/control-perfil';
import { Subscription } from 'rxjs';
import { AdminControlVehiculos } from '../control-vehiculos/control-vehiculos.component';

@Component({
  selector: 'app-control-vehiculos-destinatarios',
  templateUrl: './control-vehiculos-destinatarios.component.html',
  styleUrls: ['./control-vehiculos-destinatarios.component.scss'],
  animations: [
    trigger('fadeInUp', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(10px)' }),
        animate('200ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ]),
    trigger('listAnimation', [
      transition('* <=> *', [
        query(':enter',
          [style({ opacity: 0, transform: 'translateX(-15px)' }),
           stagger('100ms', animate('200ms ease-out', style({ opacity: 1, transform: 'translateX(0px)' })))],
          { optional: true }
        )
      ])
    ])
  ]
})
export class ControlVehiculosDestinatarios implements OnInit, OnDestroy {

  public configPerfil: any = {
    perfil: null,
    destinatarios: [],
    vehiculos: []
  };

  public nuevoDestinatario: string = '';
  public destinatariosSugeridos: any[] = [];
  public loadingDestinatarios: boolean = false;
  public loadingAdd: boolean = false;
  public loadingGuardar: boolean = false;
  public hasChanges: boolean = false;

  private perfilSubscription: Subscription;

  constructor(
    private router: Router,
    private ctrlVehiculo: ControlVehiculosService,
    private dialog: MatDialog,
    private gtp: Gtp,
    private ctrlPerfil: ControlPerfil
  ) { }

  ngOnInit(): void {
    this.cargarPerfilActual();
    this.cargarDestinatariosSugeridos();

    // Suscribirse a cambios del perfil actual
    this.perfilSubscription = this.ctrlVehiculo.getPerfilActualObs().subscribe(perfil => {
      console.log('📡 Perfil actualizado desde observable:', perfil);

      if (perfil) {
        console.log('✅ Perfil recibido del observable:', {
          nombre: perfil.perfil?.nombre,
          destinatarios: perfil.destinatarios,
          destinatariosCount: perfil.destinatarios?.length || 0,
          vehiculos: perfil.vehiculos?.length || 0
        });

        // Verificar si el perfil tiene la estructura completa
        if (perfil.perfil || perfil.destinatarios?.length > 0 || perfil.vehiculos?.length > 0) {
          this.configPerfil = {
            perfil: perfil.perfil || this.configPerfil?.perfil,
            destinatarios: perfil.destinatarios || [],
            vehiculos: perfil.vehiculos || [],
            eventos: perfil.eventos || []
          };

          console.log('🔄 configPerfil actualizado desde observable:', this.configPerfil);
        } else {
          console.log('⚠️ Perfil del observable tiene estructura incompleta, manteniendo actual');
        }

        // Asegurar que la estructura del perfil esté completa
        if (!this.configPerfil.destinatarios) {
          this.configPerfil.destinatarios = [];
          console.log('🔧 Inicializando destinatarios vacíos en observable');
        }
      } else {
        console.warn('❌ Observable devolvió perfil null/undefined');
        // Solo inicializar temporal si no tenemos datos actuales
        if (!this.configPerfil?.perfil) {
          this.initializarPerfilTemporal();
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.perfilSubscription) {
      this.perfilSubscription.unsubscribe();
    }
  }

  cargarPerfilActual() {
    // Obtener el perfil actual desde el servicio
    const perfilActual = this.ctrlVehiculo.getPerfilActual();
    console.log('🔍 DEBUG - Perfil actual cargado:', perfilActual);

    if (perfilActual) {
      // Verificar si tiene estructura completa O solo información básica del perfil
      const tieneEstructuraCompleta = perfilActual.perfil || perfilActual.destinatarios || perfilActual.vehiculos;
      const tienePerfilBasico = perfilActual.id_perfil && perfilActual.nombre;

      console.log('✅ Análisis del perfil:', {
        tieneEstructuraCompleta,
        tienePerfilBasico,
        nombre: perfilActual.nombre || perfilActual.perfil?.nombre,
        destinatarios: perfilActual.destinatarios,
        destinatariosLength: perfilActual.destinatarios?.length || 0
      });

      if (tieneEstructuraCompleta) {
        // Estructura completa - usar directamente
        this.configPerfil = {
          perfil: perfilActual.perfil || {
            id_perfil: perfilActual.id_perfil,
            nombre: perfilActual.nombre,
            cod_cliente: perfilActual.cod_cliente
          },
          destinatarios: perfilActual.destinatarios || [],
          vehiculos: perfilActual.vehiculos || [],
          eventos: perfilActual.eventos || []
        };
        console.log('✅ Usando estructura completa');
      } else if (tienePerfilBasico) {
        // Solo información básica del perfil - necesita cargar datos completos
        this.configPerfil = {
          perfil: perfilActual,
          destinatarios: [],
          vehiculos: [],
          eventos: []
        };
        console.log('⚠️ Solo información básica - puede necesitar cargar desde API');
      } else {
        console.warn('❌ Estructura de perfil no reconocida');
        this.initializarPerfilTemporal();
        return;
      }

      // Verificar si los destinatarios están cargados
      if (!this.configPerfil.destinatarios || this.configPerfil.destinatarios.length === 0) {
        console.log('⚠️ Sin destinatarios - array vacío inicializado');
      } else {
        console.log('✅ Destinatarios existentes cargados:', this.configPerfil.destinatarios);
      }
    } else {
      console.warn('❌ No hay perfil válido, inicializando perfil temporal');
      this.initializarPerfilTemporal();
    }
  }

  /**
   * Inicializa un perfil temporal para evitar errores
   */
  initializarPerfilTemporal() {
    // Verificar si hay algún perfil en el servicio pero sin estructura completa
    const perfilParcial = this.ctrlVehiculo.getPerfilActual();

    console.log('🔧 Inicializando perfil temporal con datos:', perfilParcial);

    if (perfilParcial) {
      // Completar la estructura del perfil manteniendo los datos existentes
      this.configPerfil = {
        perfil: perfilParcial.perfil || {
          nombre: 'Perfil Temporal',
          id_perfil: perfilParcial.id_perfil || null
        },
        destinatarios: perfilParcial.destinatarios || [],
        vehiculos: perfilParcial.vehiculos || [],
        eventos: perfilParcial.eventos || []
      };

      console.log('✅ Perfil temporal inicializado:', {
        nombre: this.configPerfil.perfil?.nombre,
        destinatarios: this.configPerfil.destinatarios,
        destinatariosCount: this.configPerfil.destinatarios?.length || 0
      });

      // Si hay destinatarios, mostrar mensaje informativo
      if (this.configPerfil.destinatarios?.length > 0) {
        this.gtp.infoNotif(`Perfil temporal cargado con ${this.configPerfil.destinatarios.length} destinatario(s)`);
      }
    } else {
      // No hay ningún dato, crear estructura completamente vacía
      this.configPerfil = {
        perfil: { nombre: 'Sin Perfil Seleccionado' },
        destinatarios: [],
        vehiculos: [],
        eventos: []
      };

      console.log('⚠️ Creando estructura completamente vacía');
      this.gtp.errorNotif('No hay perfil seleccionado. Por favor, seleccione un perfil primero.');
      setTimeout(() => this.volver(), 3000);
    }
  }

  /**
   * Carga la lista de destinatarios sugeridos desde la API
   */
  cargarDestinatariosSugeridos() {
    this.loadingDestinatarios = true;
    this.ctrlVehiculo.getListaDestinatarios().subscribe(
      res => {
        this.destinatariosSugeridos = res['rows'] || [];
      },
      error => {
        console.error('Error al cargar destinatarios:', error);
        this.destinatariosSugeridos = [];
        this.gtp.errorNotif('Error al cargar destinatarios sugeridos');
      },
      () => {
        this.loadingDestinatarios = false;
      }
    );
  }

  /**
   * Agrega un nuevo destinatario al perfil
   */
  agregarDestinatario() {
    if (!this.nuevoDestinatario?.trim()) {
      this.gtp.errorNotif('Por favor ingrese un destinatario válido');
      return;
    }

    // Verificar que configPerfil esté definido
    if (!this.configPerfil) {
      this.gtp.errorNotif('Error: No hay perfil seleccionado');
      return;
    }

    // Verificar si ya existe
    if (this.configPerfil.destinatarios?.includes(this.nuevoDestinatario.trim())) {
      this.gtp.errorNotif('Este destinatario ya está agregado');
      return;
    }

    // Validar formato
    if (!this.gtp.validateEmail(this.nuevoDestinatario) && !this.gtp.validatePhone(this.nuevoDestinatario)) {
      this.gtp.errorNotif('Por favor ingrese un email válido o número de teléfono');
      return;
    }

    this.loadingAdd = true;

    // Simular delay para UX
    setTimeout(() => {
      if (!this.configPerfil.destinatarios) {
        this.configPerfil.destinatarios = [];
      }

      this.configPerfil.destinatarios.push(this.nuevoDestinatario.trim());
      this.nuevoDestinatario = '';
      this.loadingAdd = false;
      this.gtp.successNotif('Destinatario agregado exitosamente');
    }, 500);
  }

  /**
   * Método para obtener versión acortada de las fuentes
   */
  getShortenedSources(fuentes: string): string {
    if (!fuentes) return '';

    const sourceMap: { [key: string]: string } = {
      'legacy': 'Legacy',
      'cliente': 'Cliente',
      'vehiculo': 'Vehículo'
    };

    const sources = fuentes.split(', ').map(source => sourceMap[source] || source);

    return sources.join(', ');
  }

  /**
   * Método para verificar si un destinatario ya existe
   */
  isDestinatarioExistente(destinatario: string): boolean {
    return this.configPerfil?.destinatarios?.includes(destinatario) || false;
  }

  /**
   * Método para trackBy en ngFor
   */
  trackByDestinatario(index: number, item: any): string {
    return item.destinatario || index.toString();
  }

  /**
   * Actualizar método para agregar destinatario sugerido
   */
  agregarDestinatarioSugerido(sugerencia: any): void {
    // Verificar que hay un perfil configurado
    if (!this.configPerfil || !this.configPerfil.perfil) {
      this.gtp.errorNotif('Error: No hay perfil seleccionado para agregar destinatarios');
      return;
    }

    // Verificar que la sugerencia es válida
    if (!sugerencia || !sugerencia.destinatario) {
      this.gtp.errorNotif('Error: Destinatario sugerido inválido');
      return;
    }

    // Verificar si ya existe
    if (this.isDestinatarioExistente(sugerencia.destinatario)) {
      this.gtp.infoNotif('Este destinatario ya está agregado al perfil');
      return;
    }

    // Inicializar destinatarios si no existe
    if (!this.configPerfil.destinatarios) {
      this.configPerfil.destinatarios = [];
    }

    try {
      // Agregar destinatario
      this.configPerfil.destinatarios.push(sugerencia.destinatario);
      this.hasChanges = true;

      console.log('Destinatario agregado desde sugerencia:', sugerencia.destinatario);
      this.gtp.successNotif(`Destinatario "${sugerencia.destinatario}" agregado exitosamente`);

    } catch (error) {
      console.error('Error agregando destinatario sugerido:', error);
      this.gtp.errorNotif('Error al agregar el destinatario sugerido');
    }
  }

  /**
   * Elimina un destinatario del perfil
   */
  eliminarDestinatario(destinatario: string, index: number) {
    // Verificar que configPerfil esté definido
    if (!this.configPerfil || !this.configPerfil.destinatarios) {
      this.gtp.errorNotif('Error: No hay perfil seleccionado o destinatarios configurados');
      return;
    }

    const dialogRef = this.dialog.open(ConfirmDialog, {
      width: this.gtp.confirmMinWidh,
      data: {
        value: destinatario,
        titulo: 'ELIMINAR DESTINATARIO',
        descr: `¿Está seguro que quiere eliminar "${destinatario}" de este perfil?`,
        success_class: 'danger',
        success_text: 'Eliminar'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && this.configPerfil?.destinatarios) {
        this.configPerfil.destinatarios.splice(index, 1);
        this.gtp.successNotif('Destinatario eliminado');
      }
    });
  }

  /**
   * Vuelve al componente principal
   */
  volver() {
    this.gtp.setMainOutlet(AdminControlVehiculos);
  }

  /**
   * Guarda los cambios realizados
   */
  guardar() {
    if (!this.configPerfil || !this.configPerfil.perfil) {
      this.gtp.errorNotif('Error: No hay perfil seleccionado');
      return;
    }

    if (!this.configPerfil.destinatarios?.length) {
      this.gtp.errorNotif('Debe agregar al menos un destinatario');
      return;
    }

    console.log('💾 Iniciando guardado con configPerfil:', this.configPerfil);

    this.loadingGuardar = true;

    // Asegurar que configPerfil tenga todas las propiedades necesarias
    const perfilCompleto = {
      perfil: this.configPerfil.perfil,
      destinatarios: this.configPerfil.destinatarios || [],
      vehiculos: this.configPerfil.vehiculos || [],
      eventos: this.configPerfil.eventos || [],
      geocercas: this.configPerfil.geocercas || [],
      mantenimiento: this.configPerfil.mantenimiento || [],
      sintransmitir: this.configPerfil.sintransmitir || [],
      movimiento: this.configPerfil.movimiento || [],
      rutas: this.configPerfil.rutas || []
    };

    console.log('📋 Perfil completo a guardar:', perfilCompleto);

    this.ctrlPerfil.updatePerfil(perfilCompleto).subscribe(
      result => {
        this.loadingGuardar = false;
        console.log('✅ Guardado exitoso:', result);
        this.gtp.successNotif('Destinatarios guardados exitosamente');

        // Actualizar el perfil en el servicio compartido con la estructura completa
        this.ctrlVehiculo.setPerfilActual(perfilCompleto);
      },
      error => {
        this.loadingGuardar = false;
        console.error('❌ Error al guardar:', error);
        this.gtp.errorNotif('Error al guardar los destinatarios');
      }
    );
  }

  /**
   * Forzar recarga de datos del perfil actual
   */
  recargarDatosPerfil() {
    console.log('🔄 Forzando recarga de datos del perfil...');

    // Intentar obtener perfil actualizado del servicio
    const perfilActualizado = this.ctrlVehiculo.getPerfilActual();

    if (perfilActualizado) {
      console.log('📊 Datos del perfil actualizado:', {
        perfil: perfilActualizado.perfil,
        destinatarios: perfilActualizado.destinatarios,
        vehiculos: perfilActualizado.vehiculos
      });

      // Actualizar solo si hay datos válidos
      if (perfilActualizado.perfil || perfilActualizado.destinatarios?.length > 0) {
        this.configPerfil = {
          perfil: perfilActualizado.perfil || this.configPerfil.perfil,
          destinatarios: perfilActualizado.destinatarios || [],
          vehiculos: perfilActualizado.vehiculos || [],
          eventos: perfilActualizado.eventos || []
        };

        console.log('✅ Perfil actualizado con éxito:', this.configPerfil);
        this.gtp.successNotif('Datos del perfil recargados');
      } else {
        console.log('⚠️ Perfil sin datos suficientes, intentando cargar desde API...');
        this.cargarPerfilDesdeAPI();
      }
    } else {
      console.log('❌ No se pudo obtener perfil actualizado del servicio');
      this.gtp.errorNotif('No se pudieron recargar los datos del perfil');

      // Intentar cargar desde API como último recurso
      this.cargarPerfilDesdeAPI();
    }
  }

  /**
   * Cargar perfil directamente desde la API (como último recurso)
   */
  cargarPerfilDesdeAPI() {
    console.log('🌐 Intentando cargar perfil desde API...');

    // Verificar si tenemos ID del perfil
    const perfilId = this.configPerfil?.perfil?.id_perfil;

    if (perfilId) {
      console.log(`📡 Cargando perfil ${perfilId} desde API...`);

      this.ctrlVehiculo.getPerfil(perfilId).subscribe(
        res => {
          const perfilData = res['rows'];
          console.log('✅ Perfil cargado desde API:', perfilData);

          if (perfilData) {
            this.configPerfil = {
              perfil: perfilData,
              destinatarios: perfilData.destinatarios || [],
              vehiculos: perfilData.vehiculos || [],
              eventos: perfilData.eventos || [],
              geocercas: perfilData.geocercas || [],
              mantenimiento: perfilData.mantenimiento || [],
              sintransmitir: perfilData.sintransmitir || [],
              rutas: perfilData.rutas || []
            };

            // Actualizar el servicio con los datos completos
            this.ctrlVehiculo.setPerfilActual(this.configPerfil);

            this.gtp.successNotif(`Perfil cargado desde API: ${this.configPerfil.destinatarios?.length || 0} destinatarios`);
          }
        },
        error => {
          console.error('❌ Error cargando perfil desde API:', error);
          this.gtp.errorNotif('Error al cargar perfil desde API');
        }
      );
    } else {
      console.log('❌ No hay ID de perfil para cargar desde API');
      this.gtp.errorNotif('No hay ID de perfil para cargar');
    }
  }

  /**
   * Verificar el estado actual del perfil
   */
  verificarEstadoPerfil() {
    console.log('🔍 ESTADO ACTUAL DEL PERFIL:');
    console.log('- configPerfil:', this.configPerfil);
    console.log('- perfil.nombre:', this.configPerfil?.perfil?.nombre);
    console.log('- destinatarios:', this.configPerfil?.destinatarios);
    console.log('- destinatarios.length:', this.configPerfil?.destinatarios?.length);
    console.log('- vehiculos.length:', this.configPerfil?.vehiculos?.length);

    // Mostrar en notificación para debug
    const estado = `Perfil: ${this.configPerfil?.perfil?.nombre || 'Sin nombre'} | Destinatarios: ${this.configPerfil?.destinatarios?.length || 0}`;
    this.gtp.infoNotif(estado);
  }
}
